module.exports = __webpack_public_path__ + "static/media/icon.ac1e8bd0.png";